import domains from '../containers/Domains';

const endpoint = domains.fbEndpoint;

export const makePost = async (data, id) => {
  const formatedData = JSON.stringify(data);
  const result = await fetch(endpoint + id, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body: formatedData
  });

  return result;
};

export default makePost;



// WEBPACK FOOTER //
// ./src/fbApi/Context.js